module.exports = __webpack_public_path__ + "img/RightMoveLogoDark.07fd855b.svg";